// extracted by mini-css-extract-plugin
export default {"body":"n12u7dgpd2yAH9_7M3Xl"};